/* eslint-disable @typescript-eslint/no-unused-vars */
import {useCallback, useMemo, useState} from 'react';
import type {EditorMode} from 'editors/types';
import type {Prize, SavePrizeFunc} from 'services/prizes/types';

//import {EditPrize} from '../components';

const createNewPrize = (): Prize => ({}) as Prize;

/**
 * Takes a save function, and returns functions to edit and add an prize, with a
 * corresponding edit dialog component.
 * @param onSave function to save new or edited prize
 * @returns
 */
export const useEditPrizeDialog = (onSave: SavePrizeFunc) => {
  const [originalPrize, setOriginalPrize] = useState<Prize>(createNewPrize());
  const [mode, setMode] = useState<EditorMode>('register');

  const [dialogOpen, setDialogOpen] = useState(false);

  const handleAddPrize = useCallback(() => {
    setOriginalPrize(createNewPrize());
    setMode('register');
    setDialogOpen(true);
  }, []);

  const handleEditPrize = useCallback((prize: Prize) => {
    setOriginalPrize(prize);
    setMode('edit');
    setDialogOpen(true);
  }, []);

  const handleSavePrize = useCallback(
    (prize: Prize) => {
      return onSave(prize).then(savedPrize => {
        setDialogOpen(false);
        return savedPrize;
      });
    },
    [onSave],
  );

  const Dialog = useCallback(() => {
    return null;
    // return (
    //   <EditPrize
    //     mode={mode}
    //     originalValue={originalPrize}
    //     onCancel={() => setDialogOpen(false)}
    //     onSave={handleSavePrize}
    //     onDelete={() => Promise.resolve()}
    //   />
    // );
  }, []);

  return useMemo(() => {
    return {
      handleAddPrize,
      handleEditPrize,
      EditPrizeDialog: Dialog,
    };
  }, [Dialog, handleAddPrize, handleEditPrize]);
};
